import { Theme } from '@infotech-soe/erp-ui-kit';
import { createUseStyles } from 'react-jss';

export const usePrivsPanelStyles = createUseStyles(({ colors }: Theme) => ({
  privsPanel: {
    '&:focus-within': {
      borderColor: colors.primary,
    },
  },
  container: {
    overflowY: 'auto',
  },
  actionTitle: {
    borderBottom: `1px solid ${colors.borderDivider}`,
  },
}));
